import React from 'react'
import { Button } from 'antd'
import Action from '@/components/Action'
import styles from './index.less'

const ActionButton = Action(Button)

export default ({ loading, onClick }) => {
    if (loading) {
        return <div className={styles.container}>正在升级快捷查询配置，请稍后...</div>
    }

    return (
        <div className={styles.container}>
            检测到快捷查询配置已升级
            <ActionButton type="link" loading={loading} onClick={onClick}>
                立即更新
            </ActionButton>
        </div>
    )
}
